/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedUploadScheduleRouteImport } from './routes/_authenticated/upload-schedule'
import { Route as AuthenticatedQuickStartRouteImport } from './routes/_authenticated/quick-start'
import { Route as AuthenticatedOrganizationRouteImport } from './routes/_authenticated/organization'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated/patients/index'
import { Route as AuthenticatedEncountersIndexRouteImport } from './routes/_authenticated/encounters/index'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedTemplatesTemplateIdRouteImport } from './routes/_authenticated/templates/$templateId'
import { Route as AuthenticatedRolesRoleIdRouteImport } from './routes/_authenticated/roles/$roleId'
import { Route as AuthenticatedPatientsNewRouteImport } from './routes/_authenticated/patients/new'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated/patients/$patientId'
import { Route as AuthenticatedEncountersNewRouteImport } from './routes/_authenticated/encounters/new'
import { Route as AuthenticatedEncountersEncounterIdRouteImport } from './routes/_authenticated/encounters/$encounterId'

const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUploadScheduleRoute =
  AuthenticatedUploadScheduleRouteImport.update({
    id: '/upload-schedule',
    path: '/upload-schedule',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuickStartRoute = AuthenticatedQuickStartRouteImport.update({
  id: '/quick-start',
  path: '/quick-start',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationRoute =
  AuthenticatedOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersIndexRoute =
  AuthenticatedEncountersIndexRouteImport.update({
    id: '/encounters/',
    path: '/encounters/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemplatesTemplateIdRoute =
  AuthenticatedTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesRoleIdRoute =
  AuthenticatedRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsNewRoute =
  AuthenticatedPatientsNewRouteImport.update({
    id: '/patients/new',
    path: '/patients/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersNewRoute =
  AuthenticatedEncountersNewRouteImport.update({
    id: '/encounters/new',
    path: '/encounters/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersEncounterIdRoute =
  AuthenticatedEncountersEncounterIdRouteImport.update({
    id: '/encounters/$encounterId',
    path: '/encounters/$encounterId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/organization': typeof AuthenticatedOrganizationRoute
  '/quick-start': typeof AuthenticatedQuickStartRoute
  '/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/users': typeof AuthenticatedUsersRoute
  '/s/$token': typeof STokenRoute
  '/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/encounters': typeof AuthenticatedEncountersIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/organization': typeof AuthenticatedOrganizationRoute
  '/quick-start': typeof AuthenticatedQuickStartRoute
  '/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/users': typeof AuthenticatedUsersRoute
  '/s/$token': typeof STokenRoute
  '/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/encounters': typeof AuthenticatedEncountersIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_authenticated/organization': typeof AuthenticatedOrganizationRoute
  '/_authenticated/quick-start': typeof AuthenticatedQuickStartRoute
  '/_authenticated/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/s/$token': typeof STokenRoute
  '/_authenticated/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/_authenticated/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/_authenticated/patients/new': typeof AuthenticatedPatientsNewRoute
  '/_authenticated/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/_authenticated/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/encounters/': typeof AuthenticatedEncountersIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/set-password'
    | '/organization'
    | '/quick-start'
    | '/upload-schedule'
    | '/users'
    | '/s/$token'
    | '/encounters/$encounterId'
    | '/encounters/new'
    | '/patients/$patientId'
    | '/patients/new'
    | '/roles/$roleId'
    | '/templates/$templateId'
    | '/documents'
    | '/encounters'
    | '/patients'
    | '/roles'
    | '/templates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/set-password'
    | '/organization'
    | '/quick-start'
    | '/upload-schedule'
    | '/users'
    | '/s/$token'
    | '/encounters/$encounterId'
    | '/encounters/new'
    | '/patients/$patientId'
    | '/patients/new'
    | '/roles/$roleId'
    | '/templates/$templateId'
    | '/documents'
    | '/encounters'
    | '/patients'
    | '/roles'
    | '/templates'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/set-password'
    | '/_authenticated/organization'
    | '/_authenticated/quick-start'
    | '/_authenticated/upload-schedule'
    | '/_authenticated/users'
    | '/s/$token'
    | '/_authenticated/encounters/$encounterId'
    | '/_authenticated/encounters/new'
    | '/_authenticated/patients/$patientId'
    | '/_authenticated/patients/new'
    | '/_authenticated/roles/$roleId'
    | '/_authenticated/templates/$templateId'
    | '/_authenticated/documents/'
    | '/_authenticated/encounters/'
    | '/_authenticated/patients/'
    | '/_authenticated/roles/'
    | '/_authenticated/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upload-schedule': {
      id: '/_authenticated/upload-schedule'
      path: '/upload-schedule'
      fullPath: '/upload-schedule'
      preLoaderRoute: typeof AuthenticatedUploadScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quick-start': {
      id: '/_authenticated/quick-start'
      path: '/quick-start'
      fullPath: '/quick-start'
      preLoaderRoute: typeof AuthenticatedQuickStartRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization': {
      id: '/_authenticated/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthenticatedOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/': {
      id: '/_authenticated/encounters/'
      path: '/encounters'
      fullPath: '/encounters'
      preLoaderRoute: typeof AuthenticatedEncountersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates/$templateId': {
      id: '/_authenticated/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/$roleId': {
      id: '/_authenticated/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/new': {
      id: '/_authenticated/patients/new'
      path: '/patients/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof AuthenticatedPatientsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/new': {
      id: '/_authenticated/encounters/new'
      path: '/encounters/new'
      fullPath: '/encounters/new'
      preLoaderRoute: typeof AuthenticatedEncountersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/$encounterId': {
      id: '/_authenticated/encounters/$encounterId'
      path: '/encounters/$encounterId'
      fullPath: '/encounters/$encounterId'
      preLoaderRoute: typeof AuthenticatedEncountersEncounterIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRoute
  AuthenticatedQuickStartRoute: typeof AuthenticatedQuickStartRoute
  AuthenticatedUploadScheduleRoute: typeof AuthenticatedUploadScheduleRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedEncountersEncounterIdRoute: typeof AuthenticatedEncountersEncounterIdRoute
  AuthenticatedEncountersNewRoute: typeof AuthenticatedEncountersNewRoute
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedPatientsNewRoute: typeof AuthenticatedPatientsNewRoute
  AuthenticatedRolesRoleIdRoute: typeof AuthenticatedRolesRoleIdRoute
  AuthenticatedTemplatesTemplateIdRoute: typeof AuthenticatedTemplatesTemplateIdRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedEncountersIndexRoute: typeof AuthenticatedEncountersIndexRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRoute,
  AuthenticatedQuickStartRoute: AuthenticatedQuickStartRoute,
  AuthenticatedUploadScheduleRoute: AuthenticatedUploadScheduleRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedEncountersEncounterIdRoute:
    AuthenticatedEncountersEncounterIdRoute,
  AuthenticatedEncountersNewRoute: AuthenticatedEncountersNewRoute,
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedPatientsNewRoute: AuthenticatedPatientsNewRoute,
  AuthenticatedRolesRoleIdRoute: AuthenticatedRolesRoleIdRoute,
  AuthenticatedTemplatesTemplateIdRoute: AuthenticatedTemplatesTemplateIdRoute,
  AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  AuthenticatedEncountersIndexRoute: AuthenticatedEncountersIndexRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
